// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J0AynUvkWJLw5Zd4Tvfr {
  color: #FFF;
  font-family: 'Montserrat';
  transition: 0.2s;
  background-color: #034EA2;
  height: 300px;
}

.J0AynUvkWJLw5Zd4Tvfr:hover{
  background-color: #013CA3;
  box-shadow: 0 0 2rem rgba(0,0,0,0.2);
  transition: all 0.2s ease-in-out;
  cursor: pointer;
};

.M1m6qRCxpi3piqNBccLI{
  display: grid;
  padding: 1.4rem;
}

.kt8AVjD2Iq6428ClQx2z{
  font-weight: 800;
  color: #FFF;
}

.kmAQBDsCLKPNPJuHgkku{
  font-weight: 400;
  font-size: 1rem;
}

.X41KY6Z4EA4Ay_jGCVB9 {
  width: 30px;
  height: 30px;
}

.jhazv1SZe3HoClx2tpHE{
  flex: 1 1 100%;
  min-height: 250px;
}

@media (min-width: 768px) {
  .jhazv1SZe3HoClx2tpHE{
    flex: 1 1 40%;
  }
}

@media (min-width: 1024px) {
  .jhazv1SZe3HoClx2tpHE{
    flex: 1 1 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CardCartilha/index.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB,CAAA;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".card {\n  color: #FFF;\n  font-family: 'Montserrat';\n  transition: 0.2s;\n  background-color: #034EA2;\n  height: 300px;\n}\n\n.card:hover{\n  background-color: #013CA3;\n  box-shadow: 0 0 2rem rgba(0,0,0,0.2);\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n};\n\n.grid{\n  display: grid;\n  padding: 1.4rem;\n}\n\n.h3{\n  font-weight: 800;\n  color: #FFF;\n}\n\n.p{\n  font-weight: 400;\n  font-size: 1rem;\n}\n\n.icon {\n  width: 30px;\n  height: 30px;\n}\n\n.container{\n  flex: 1 1 100%;\n  min-height: 250px;\n}\n\n@media (min-width: 768px) {\n  .container{\n    flex: 1 1 40%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .container{\n    flex: 1 1 30%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `J0AynUvkWJLw5Zd4Tvfr`,
	"grid": `M1m6qRCxpi3piqNBccLI`,
	"h3": `kt8AVjD2Iq6428ClQx2z`,
	"p": `kmAQBDsCLKPNPJuHgkku`,
	"icon": `X41KY6Z4EA4Ay_jGCVB9`,
	"container": `jhazv1SZe3HoClx2tpHE`
};
export default ___CSS_LOADER_EXPORT___;
